// Custom Featured 

document.addEventListener("DOMContentLoaded", function() {
  var thumbSwiper = new Swiper(".custom_featured_product .thumbSwiper", {
    spaceBetween: 22,
    slidesPerView: 6,
    watchSlidesProgress: true,
    loop: false, 
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      769: { 
        direction: "vertical",
      },
      481: { 
        direction: "horizontal",
      },
0: { 
          slidesPerView: 3.5,
      }
    }
  });

  var featuredSwiper = new Swiper(".custom_featured_product .featuredSwiper", {
    spaceBetween: 1,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  });
});





$(document).ready(function(){
  
$(document).ready(function () {

    setTimeout(function () {
        $(".custom_bundles_wrap .custom_bundles").eq(1).click();
    }, 100);

    $(".custom_bundles_wrap .custom_bundles").click(function () {

        $(".custom_bundles_wrap .custom_bundles").removeClass('active');


        $(this).addClass('active');


        let selectedIndex = $(this).attr("data-index");


        $('.quantity__input[type="number"]').val(selectedIndex);

        $(".custom_Subscription_block .sub_price").hide();
     $(".custom_featured_product .product_price_container .price_wrapper").hide();


 $(".custom_featured_product .product_price_container .price_wrapper[data-index='" + selectedIndex + "']").show();
        $(".custom_Subscription_block  .sub_price[data-index='" + selectedIndex + "']").show();
    });
});
 
    // setTimeout(function(){

    //     $(".custom_bundles_wrap .custom_bundles").eq(1).click();  
    // }, 100);  
    
    // $(".custom_bundles_wrap .custom_bundles").click(function(){  

    //    $(".custom_bundles_wrap .custom_bundles").removeClass('active');
       

    //    $(this).addClass('active');
       
    //    var indxxx = $(this).attr('data-index');
    //    $('.quantity__input[type="number"]').val(indxxx);


    // });
  // ///////////////////////////////////////////

  $(".custom_featured_product .custom_faq_wrap .faq .faq-answer").hide();
  $(".custom_featured_product .custom_faq_wrap .faq .faq-question:first").next(".faq-answer").show();
  $(".custom_featured_product .custom_faq_wrap .faq .faq-question:first").find(".faq-toggle.plus").hide();
  $(".custom_featured_product .custom_faq_wrap .faq .faq-question:first").find(".faq-toggle.mins").show();


  $(".custom_featured_product .custom_faq_wrap .faq .faq-question").click(function() {
    var $faqAnswer = $(this).next(".faq-answer");
    var $plusIcon = $(this).find(".faq-toggle.plus");
    var $minsIcon = $(this).find(".faq-toggle.mins");


    if ($faqAnswer.is(":visible")) {
      $faqAnswer.slideUp();
      $plusIcon.show();
      $minsIcon.hide();
    } else {

      $(".custom_featured_product .custom_faq_wrap .faq .faq-answer").slideUp();
      $(".custom_featured_product .custom_faq_wrap .faq .faq-toggle.plus").show();
      $(".custom_featured_product .custom_faq_wrap .faq .faq-toggle.mins").hide();


      $faqAnswer.slideDown();
      $plusIcon.hide();
      $minsIcon.show();
    }
  });

//////////////////////////////
  $('.custom_banner_section .custom_button, .custom_header .custom_button, .custom_animate_text .wrapper .right_block .bottom_button, .custom_banner_section .wrapper .banner_container .bottom_button, .custom_ingredients .top_btn, .custom_compare_section .compare__wrapper .compare_right .heaing_btn_wrap .top_btn, .custom_compare_section .compare__wrapper .compare_right .price_btn_wrap .bottom_btn, .custom_banner_2 .wrapper .banner_container .bottom_button').on('click', function() {
    
    $('html, body').animate({
      scrollTop: $('.custom_featured_product').offset().top
    }, 1000); 
  });
////////////////////////////////
    $(".custom_Subscription_block:first").addClass("active");
    $(".custom_Subscription_block").click(function () {
        $(".custom_Subscription_block").removeClass("active");
        $(this).addClass("active"); 
    });

///////////////////////////////
    setTimeout(function() {
        $('.custom_Subscription_container .custom_Subscription_block.save_subscription').click();
    }, 2000);

  
    $('.custom_Subscription_container .custom_Subscription_block.save_subscription').click(function() {
        var panId = $(this).attr('pan_id');
        $('.custom_featured_product .product-form input[type="hidden"][name="selling_plan"]').val(panId);
    });


    $('.custom_Subscription_container .custom_Subscription_block.one_time').click(function() {
        $('.custom_featured_product .product-form input[type="hidden"][name="selling_plan"]').val('');
    });

////////////////////
    $(".custom_animate_text .animate_heading").each(function () {
        var $this = $(this);
        var countTo = parseInt($this.text().replace('%', ''));

        $({ countNum: 0 }).animate(
            { countNum: countTo },
            {
                duration: 2000,
                easing: "swing",
                step: function () {
                    $this.text(Math.floor(this.countNum) + "%");
                },
                complete: function () {
                    $this.text(this.countNum + "%");
                }
            }
        );
    });

});

///////////////////////
 $('.custom_flip_block .plus_icon').on('click', function() {
    var $flipWrap = $(this).closest('.flip_block_wrap');
    

    $flipWrap.toggleClass('flip');
  });


///////////////////////
  $('.custom_banner_2 .custom_reviews, .custom_banner_section .custom_reviews, .custom_featured_product .custom_reviews, .inst_stories_slider .page_wrapper .star_rating').on('click', function() {
    $('html, body').animate({
      scrollTop: $('.new_custom_review_section').offset().top
    }, 1000); 
  });

///////////////////////
  $('.custom_ingredients .plus_icon').on('click', function() {
    var $flipWrap = $(this).closest('.ingredients_block');
    

    $flipWrap.toggleClass('flip');
  });


///////////////////////
  $('.custom_ingredients .view_more_ingredient').click(function() {
        const hiddenBlocks = $('.ingredients_block_wrapper .ingredients_block:nth-last-child(-n+3)');
        
        if (hiddenBlocks.is(':visible')) {
            hiddenBlocks.slideUp();
            $(this).text('View More +');
        } else {
            hiddenBlocks.slideDown();
            $(this).text('View Less -');
        }
    });
    $('.ingredients_block_wrapper .ingredients_block:nth-last-child(-n+3)').hide();

///////////////////////////////////
  if ($(window).width() >= 581) {

    const observer = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {


  
            gsap.to('.custom_transformation .block_wrapper', {
              duration: 1,
              onStart: function () {
                $('.custom_transformation .block_wrapper').addClass('animate');
              }
            });

            $('.custom_transformation .block_wrapper').on('transitionend', function () {
              var tl = gsap.timeline();
              $('.custom_transformation .block_wrapper .main_block').each(function (index, element) {
                tl.to($(element), {
                  duration: 0.1,
                  opacity: 1,
                  delay: 0 * index,
                })
                  .to($(element).find('.block_heading img'), {
                    duration: 0.1,
                    opacity: 1,
                    delay: 0,
                  })
                  .to($(element).find('.content_block'), {
                    duration: 0.1,
                    opacity: 1,
                    delay: 0,
                  })
                  .to($(element).find('.block_heading h3'), {
                    duration: 0.1,
                    opacity: 1,
                    delay: 0,
                  });
              });
            });


            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: [0.1],
      }
    );

 
    const target = document.querySelector('.custom_transformation');
    if (target) {
      observer.observe(target);
    }
  }

/////////////////////////
  if ($(window).width() <= 580) { // Applies to screen widths 580px and below
    const observer = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
            gsap.to('.custom_transformation .block_wrapper', {
              duration: 2,
              onStart: function () {
                $('.custom_transformation .block_wrapper').addClass('animate');
              }
            });

            $('.custom_transformation .block_wrapper').on('transitionend', function () {
              var tl = gsap.timeline();
              $('.custom_transformation .block_wrapper .main_block').each(function (index, element) {
                tl.to($(element), {
                  duration: 0.2,
                  opacity: 1,
                  delay: 0 * index,
                })
                  .to($(element).find('.block_heading img'), {
                    duration: 0.2,
                    opacity: 1,
                    delay: 0,
                  })
                  .to($(element).find('.block_heading h3'), {
                    duration: 0.2,
                    opacity: 1,
                    delay: 0,
                  })
                  .to($(element).find('.content_block'), {
                    duration: 0.2,
                    opacity: 1,
                    delay: 0,
                  });
              });
            });

            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: [0.2],
      }
    );

    const target = document.querySelector('.custom_transformation');
    if (target) {
      observer.observe(target);
    }
  }


/////////////////////////////
document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".fine_swiper-container", {
        slidesPerView: 3.5, // Default for larger screens
        spaceBetween: 15,
        loop: false,
        breakpoints: {
            320: { 
                slidesPerView: 1.2,
                spaceBetween: 10
            },
            480: { 
                slidesPerView: 1.2,
                spaceBetween: 10
            },
            768: { 
                slidesPerView: 2.5,
                spaceBetween: 12
            },
            1024: { 
                slidesPerView: 3.2,
                spaceBetween: 15
            },
            1280: { 
                slidesPerView: 3.5,
                spaceBetween: 15
            }
        }
    });
});

///////////////////////////////////
  $('.custom_faq .tab_heading_content_wrap').each(function(index) {
    if(index !== 1) { 
      $(this).find('.tab_content').hide();
      $(this).find('.tab_heading span').removeClass('rotated');
      $(this).removeClass('active'); 
    } else {
      $(this).find('.tab_content').show(); 
      $(this).find('.tab_heading span').addClass('rotated'); 
      $(this).addClass('active'); 
    }
  });
  $('.custom_faq .tab_heading').click(function() {
    var currentTab = $(this).closest('.tab_heading_content_wrap');
    if(currentTab.find('.tab_content').is(':visible')) {
      currentTab.find('.tab_content').slideUp(); 
      $(this).find('span').removeClass('rotated'); 
      currentTab.removeClass('active');
    } else {
      $('.custom_faq .tab_heading_content_wrap').removeClass('active'); 
      $('.tab_content').slideUp(); 
      $('.tab_heading span').removeClass('rotated'); 
      currentTab.find('.tab_content').slideDown();
      $(this).find('span').addClass('rotated');
      currentTab.addClass('active'); 
    }
  });


///////////////////

    // Show popup and add CSS to body on click
    $('.custom_animate_text .wrapper .right_block .right_sub_content.pop_up').on('click', function() {
        $('.custom_animate_text .slide_popup').show();
        $('body').css('overflow', 'hidden');
    });

    // Hide popup and remove CSS from body on click
    $('.custom_animate_text .slide_popup .popup_wrapper .wrapper_icon').on('click', function() {
        $('.custom_animate_text .slide_popup').hide();
        $('body').css('overflow', 'auto');
    });

